(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-promise-section"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var brandPromiseBar = document.querySelector('.brand-promise-bar');
  if (brandPromiseBar) {
    var textColumns = brandPromiseBar.querySelectorAll('.brand-promise-columns__column--text');
    var currentIndex = 0;
    var animationDelay = parseInt(brandPromiseBar.dataset.animationDelay) || 5000; // Default to 5 seconds if parsing fails
    var transitionDuration = 500; // Duration of fade in/out in milliseconds

    // Ensure a minimum delay of 1 second plus transition duration
    animationDelay = Math.max(animationDelay, 1000 + transitionDuration * 2);

    function updateDynamicDelivery() {
      var dynamicDeliveryBlock = brandPromiseBar.querySelector('.dynamic-delivery');
      if (dynamicDeliveryBlock) {
        var beforeCutoff = dynamicDeliveryBlock.dataset.beforeCutoff;
        var afterCutoff = dynamicDeliveryBlock.dataset.afterCutoff;
        var cutoffTime = dynamicDeliveryBlock.dataset.cutoffTime;

        var now = new Date();
        var [cutoffHours, cutoffMinutes] = cutoffTime.split(':').map(Number);
        var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHours, cutoffMinutes);

        var message = now < cutoff ? beforeCutoff : afterCutoff;
        dynamicDeliveryBlock.querySelector('.brand-promise-column__text').textContent = message;
      }
    }

    function showNextText() {
      var current = textColumns[currentIndex];
      currentIndex = (currentIndex + 1) % textColumns.length;
      var next = textColumns[currentIndex];

      // Fade out current text
      current.classList.remove('active');
      current.classList.add('fade-out');

      // After fade out, switch to next text and fade it in
      setTimeout(() => {
        current.style.display = 'none';
        current.classList.remove('fade-out');
        
        next.style.display = 'block';
        next.classList.add('active', 'fade-in');

        // Remove fade-in class after transition
        setTimeout(() => {
          next.classList.remove('fade-in');
        }, transitionDuration);
      }, transitionDuration);
    }

    function startTextCarousel() {
      updateDynamicDelivery(); // Update dynamic delivery message

      if (window.innerWidth <= 767 && textColumns.length > 1) {
        if (!brandPromiseBar.textCarouselInterval) {
          textColumns.forEach((column, index) => {
            column.style.display = index === 0 ? 'block' : 'none';
          });
          brandPromiseBar.textCarouselInterval = setInterval(showNextText, animationDelay);
        }
      } else {
        if (brandPromiseBar.textCarouselInterval) {
          clearInterval(brandPromiseBar.textCarouselInterval);
          brandPromiseBar.textCarouselInterval = null;
        }
        textColumns.forEach(column => {
          column.style.display = 'block';
          column.classList.add('active');
        });
      }
    }

    // Initial start with a slight delay to ensure everything is loaded
    setTimeout(startTextCarousel, 100);
    
    window.addEventListener('resize', startTextCarousel);

    // Update dynamic delivery message every minute
    setInterval(updateDynamicDelivery, 60000);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalogue-image-with-text-overlay"] && !window.DesignMode) return;
  try {
    
    let overlayWrapper = document.querySelectorAll('h2');
    var overlayArr = Array.from(overlayWrapper);

    function getEveryOverlayEL(overlayArr) {
        const result = [];
        for (var i = 0; i < overlayArr.length; i++) {
            result.push(overlayArr[i]);
        }

        return result;
    }

    const containerOverlayELArray = getEveryOverlayEL(overlayWrapper);
    containerOverlayELArray.forEach((el, index) => {
        if (index == 0) {
            var text = el.innerHTML;
            if (text.includes('Flower &amp; Gift Delivery')) {
                el.innerHTML =
                    '<h2 class="collection_heading"> Flower &amp; Gift Delivery <br><span class="subline">Made with <span>heart</span> and <span>soul</span> by Real Artisans</span> </h2>';
            }
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !window.DesignMode) return;
  try {
    
  function updateHeading() {
    var currentDate = new Date();
    var isSunday = currentDate.getDay() === 0;
    
    var currentHour = currentDate.toLocaleTimeString([], {
      timeZone: 'Africa/Johannesburg',
      hour12: false,
      hour: '2-digit',
    });

    var beforeHeading = document.querySelector('.heading-before-1pm');
    var afterHeading = document.querySelector('.heading-after-1pm');

    if (beforeHeading && afterHeading) {
      if (isSunday || currentHour >= 13) {
        beforeHeading.style.display = 'none';
        afterHeading.style.display = 'inline';
      } else {
        beforeHeading.style.display = 'inline';
        afterHeading.style.display = 'none';
      }
    }
  }

  var removeProductAdd = document.querySelectorAll('.product-form');
  removeProductAdd.forEach((element) => {
    element.style.display = 'none';
  });

  updateHeading();
  setInterval(updateHeading, 60000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-metaobjects-products"] && !window.DesignMode) return;
  try {
    
function updateHeading() {
  var currentDate = new Date();
  var isSunday = currentDate.getDay() === 0;
  
  var currentHour = currentDate.toLocaleTimeString([], {
    timeZone: 'Africa/Johannesburg',
    hour12: false,
    hour: '2-digit',
  });

  var beforeHeading = document.querySelector('.mo-heading--before');
  var afterHeading = document.querySelector('.mo-heading--after');

  if (beforeHeading && afterHeading) {
    if (isSunday || currentHour >= 13) {
      beforeHeading.style.display = 'none';
      afterHeading.style.display = 'inline';
    } else {
      beforeHeading.style.display = 'inline';
      afterHeading.style.display = 'none';
    }
  }
}


updateHeading();

setInterval(updateHeading, 60000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  $(document).ready(function () {
    $('#redirect_link').on('click', function (e) {
      e.preventDefault();
      window.location.href = 'https://dashboard.bloomable.com/';
    });
  });

  var xpath = "//a[text()='Login as Partner']";
  var matchingElement = document.evaluate(
    xpath,
    document,
    null,
    XPathResult.FIRST_ORDERED_NODE_TYPE,
    null,
  ).singleNodeValue;
  if (matchingElement) {
    matchingElement.style.background = '#252525';
    matchingElement.style.color = '#fff';
    matchingElement.style.padding = '8px 13px';
    matchingElement.style.minWidth = '150px';
    matchingElement.style.fontWeight = '600';
    matchingElement.style.borderRadius = '3px';
    matchingElement.style.display = 'block';
    matchingElement.style.display = 'block';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-collection"]) return;
  try {
    
  $(document).ready(function () {
    let descriptionWrapper = document.querySelectorAll('.custom-description > p');
    var descArray = Array.from(descriptionWrapper);
    var paragraphCount = descArray.length;

    // Toggle button click event
    document.getElementById('shower').addEventListener('click', function () {
      let button = this;
      let buttonText = button.innerText.trim().toLowerCase();

      if (buttonText === 'read more') {
        // Show all paragraphs
        descriptionWrapper.forEach((el) => {
          el.style.display = 'block';
        });
        // Change button text to "Read Less"
        button.innerText = 'Read Less';
      } else {
        // Hide all paragraphs except the first one
        descriptionWrapper.forEach((el, index) => {
          el.style.display = index === 0 ? 'block' : 'none';
        });
        // Change button text to "Read More"
        button.innerText = 'Read More';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
    var show_cart_continue = false;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metafield-product-row"] && !window.DesignMode) return;
  try {
    
  // Time-based heading update function
  function updateHeading() {
    var currentDate = new Date();
    var isSunday = currentDate.getDay() === 0; // 0 is Sunday
    
    var currentHour = currentDate.toLocaleTimeString([], {
      timeZone: 'Africa/Johannesburg',
      hour12: false,
      hour: '2-digit',
    });

    var beforeHeading = document.querySelector('.heading-before-1pm');
    var afterHeading = document.querySelector('.heading-after-1pm');

    if (beforeHeading && afterHeading) {
      if (isSunday || currentHour >= 13) {
        beforeHeading.style.display = 'none';
        afterHeading.style.display = 'inline';
      } else {
        beforeHeading.style.display = 'inline';
        afterHeading.style.display = 'none';
      }
    }
  }

  // Remove product add buttons
  var removeProductAdd = document.querySelectorAll('.product-form');
  removeProductAdd.forEach((element) => {
    element.style.display = 'none';
  });

  // Run on page load
  updateHeading();
  // Update every minute
  setInterval(updateHeading, 60000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["same-day-timer"] && !window.DesignMode) return;
  try {
    
  const targetTime = `T13:00:00`;
  const dateNow = new Date().getTime();

  let dateTommorrow = dateNow + 86400000;
  let test = new Date(dateTommorrow).toISOString();
  const currentTime = test.slice(0, 10);

  const testDateTime = `${currentTime}${targetTime}`;

  (() => {
    var timerEl = document.getElementById('timerMain');

    timerEl.addEventListener('click', removeTimer);

    const timerContent = document.getElementById('timerContent');

    const startHr = 4;
    const endHr = 12;

    const currentHourMain = new Date().toLocaleTimeString([], {
      timeZone: 'Africa/Johannesburg',
      hour12: false,
      hour: '2-digit',
    });

    if (currentHourMain >= 0 && currentHourMain < 13) {
      const x = setInterval(clockTimer, 1000);
    } else {
      timerOffEl(timerContent);
    }
  })();

  const targetTimeNow = new Date(testDateTime).getTime();

  function clockTimer() {
    // Today's date and time
    let dateNow = new Date().getTime();

    // Find the distance between now and the Taget Date & Time + 24 Hours
    let distance = targetTimeNow - dateNow;

    // Time calculations for days, hours, minutes and seconds
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let daysDigits = days < 10 ? `0${days}` : days;

    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let hrDigits = hours < 10 ? `0${hours}` : hours;

    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let minDigits = minutes < 10 ? `0${minutes}` : minutes;

    let seconds = Math.floor((distance % (1000 * 60)) / 1000);
    let secDigits = seconds < 10 ? `0${seconds}` : seconds;

    timerActiveEl(hrDigits, minDigits, secDigits);
    // console.log(hours);
    // console.log(distance);
  }

  function removeTimer(e) {
    let timerDiv = document.getElementById('timerMain');
    timerDiv.style.display = 'none';
  }

  function timerActiveEl(hh, mm, ss) {
    let timerContent = document.getElementById('timerContent');
    timerContent.innerHTML = '';

    const timerSecondaryDiv = document.createElement('div');

    const text = document.createElement('p');

    const timer = document.createElement('h4');
    timer.style.color = '#de92bf';

    text.innerHTML = `Same-Day <br /> Delivery `;
    timer.innerHTML = `${hh}:${mm} <br /><span>TIME LEFT</span>`; //:${ss}

    timerSecondaryDiv.appendChild(text);
    timerSecondaryDiv.appendChild(timer);

    timerContent.appendChild(timerSecondaryDiv);
  }

  function timerOffEl(timerContent) {
    var timerEl = document.getElementById('timerMain');
    timerEl.style.display = 'none';
    timerContent.innerHTML = '';

    const timerSecondaryDiv = document.createElement('div');

    const text = document.createElement('p');
    text.innerHTML = `Same-Day <br /> Delivery`;
    const timer = document.createElement('h4');
    timer.innerHTML = `CLOSED <br /> <span>TIME LEFT</span>`;

    timer.style.color = '#de92bf';

    timerSecondaryDiv.appendChild(text);
    timerSecondaryDiv.appendChild(timer);

    timerContent.appendChild(timerSecondaryDiv);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-feature-6"] && !window.DesignMode) return;
  try {
    
function updateDeliveryCountdown() {
  const now = new Date();
  const saTZ = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Africa/Johannesburg',
    hour: 'numeric',
    hour12: false
  });
  const currentHour = parseInt(saTZ.format(now));
  
  const deliveryBlocks = document.querySelectorAll('.delivery-countdown');
  deliveryBlocks.forEach((block) => {
    const titleElement = block.querySelector('.delivery-title');
    const subtextElement = block.querySelector('.delivery-subtext');
    const beforeText = block.getAttribute('data-before-1pm-text');
    const afterText = block.getAttribute('data-after-1pm-text');
    
    if (currentHour < 13) {
      titleElement.textContent = "Get it delivered today";
      subtextElement.textContent = beforeText;
    } else {
      titleElement.textContent = "Get it delivered tomorrow";
      subtextElement.textContent = afterText;
    }
  });
}

document.addEventListener('DOMContentLoaded', updateDeliveryCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-columns-with-images"] && !window.DesignMode) return;
  try {
    
  let imgWrapper = document.querySelectorAll('.text-column');
  var imgColumnArr = Array.from(imgWrapper);
  function getEveryTitleEL(imgColumnArr) {
    const result = [];
    for (var i = 0; i < imgColumnArr.length; i++) {
      result.push(imgColumnArr[i]);
    }

    return result;
  }

  const containerImgELArray = getEveryTitleEL(imgWrapper);
  containerImgELArray.forEach((el, index) => {
    setTimeout(() => {
      el.insertAdjacentHTML('beforebegin', '<a href="hhtp"> ');
      el.insertAdjacentHTML('afterend', '</a>');
    }, '5000');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons-time"] && !window.DesignMode) return;
  try {
    
  const currentHour = new Date().toLocaleTimeString([], {
    timeZone: 'Africa/Johannesburg',
    hour12: false,
    hour: '2-digit',
  });

  let titleWrapper = document.querySelectorAll('.time_icon');
  let textWrapper = document.querySelectorAll('.time_icon_text');

  if (currentHour >= 6 && currentHour <= 12) {
    var text = `Get it delivered today`;
    var subtext = `Order by 1PM for Nationwide Delivery by Your Local Florist`;
  } else {
    var text = `Get it tomorrow `;
    var subtext = `Get nationwide delivery by your local florist`;
  }

  var titleArr = Array.from(titleWrapper);

  function getEveryTitleEL(titleArr) {
    const result = [];
    for (var i = 0; i < titleArr.length; i++) {
      result.push(titleArr[i]);
    }

    return result;
  }

  const containerELArray = getEveryTitleEL(titleWrapper);
  titleWrapper.forEach((el, index) => {
    if (index == 0) {
      el.innerText = `${text}`;
    }
  });

  var textArr = Array.from(textWrapper);

  function getEveryTextEL(textArr) {
    const result = [];
    for (var i = 0; i < textArr.length; i++) {
      result.push(textArr[i]);
    }

    return result;
  }

  textWrapper.forEach((el, index) => {
    if (index == 0) {
      el.innerText = `${subtext}`;
    }
  });
  textWrapper.forEach((el, index) => {
    if (index == 1) {
      el.style.cssText = `margin-left: 1rem; padding-right: 10%`;
    }
  });

  let prodWrapper = document.querySelectorAll('.time_icon_img');

  function getEveryimageEL(textArr) {
    const result = [];
    for (var i = 0; i < textArr.length; i++) {
      result.push(textArr[i]);
    }
    return result;
  }

  prodWrapper.forEach((el, index) => {
    if (index == 2) {
      el.innerHTML += ` <span class="fa fa-star checked" style="padding-top: 25px;"></span> <span class="fa fa-star checked"></span> <span class="fa fa-star checked"></span> 
           <span class="fa fa-star checked"></span> <span class="fa fa-star checked"></span>`;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !window.DesignMode) return;
  try {
    
    const currentHourIcon = new Date().toLocaleTimeString([], {
        timeZone: 'Africa/Johannesburg',
        hour12: false,
        hour: '2-digit',
    });

    let topIcons = document.querySelectorAll('.icon-column__title');

    topIcons.forEach((el, index) => {
        if (index == 1) {
            if (currentHourIcon >= 12) {
                var innerContent = el.innerText;
                if (innerContent == 'SAME-DAY DELIVERY AVAILABLE') {
                    el.innerText = 'NEXT-DAY DELIVERY AVAILABLE';
                }
            }
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-partner-list"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('partner-search-{{ section.id }}');
  const filterButtons = document.querySelectorAll('#section-{{ section.id }} .filter-btn');
  const partnerCards = document.querySelectorAll('#section-{{ section.id }} .partner-card');
  const resultsCounter = document.getElementById('results-counter-{{ section.id }}');
  
  let currentFilter = 'all';
  let currentSearchTerm = '';
  
  function updateResultsCounter() {
    const visibleCards = Array.from(partnerCards).filter(card => card.style.display !== 'none').length;
    resultsCounter.textContent = `Showing ${visibleCards} of ${partnerCards.length} partners`;
  }
  
  function filterCards() {
    partnerCards.forEach(card => {
      const searchText = card.textContent.toLowerCase();
      const matchesSearch = searchText.includes(currentSearchTerm.toLowerCase());
      
      let matchesFilter = true;
      if (currentFilter === 'verified') {
        matchesFilter = card.dataset.verified === 'true';
      } else if (currentFilter === 'same-day') {
        matchesFilter = card.dataset.sameDay === 'true';
      } else if (currentFilter === 'local') {
        matchesFilter = card.dataset.local === 'true';
      }
      
      card.style.display = (matchesSearch && matchesFilter) ? 'flex' : 'none';
    });
    
    updateResultsCounter();
  }
  
  // Search functionality
  if (searchInput) {
    searchInput.addEventListener('input', function(e) {
      currentSearchTerm = e.target.value;
      filterCards();
    });
  }
  
  // Filter functionality
  filterButtons.forEach(button => {
    button.addEventListener('click', function() {
      filterButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      currentFilter = this.dataset.filter;
      filterCards();
    });
  });
  
  // Initial count
  updateResultsCounter();
});

  } catch(e) { console.error(e); }
})();
})();
